import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {PeriodScheduleSearchModel} from "../period-schedule-search.model";
import {PeriodScheduleSearchPageComponent} from "../period-schedule-search-page/period-schedule-search-page.component";
import {PeriodScheduleEditPageComponent} from "../period-schedule-edit-page/period-schedule-edit-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-period-schedule-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        provideSearchModel(PeriodScheduleSearchModel),
        registerSelectEditControl(PeriodScheduleSingleSelectEditControlComponent)
    ]
})
export class PeriodScheduleSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PeriodScheduleSearchModel> {
    constructor(model: PeriodScheduleSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = PeriodScheduleSearchPageComponent;
        this.extendedEditComponent = PeriodScheduleEditPageComponent;
    }
}
